import React from "react"

const MenuIcon = ({ size }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" height="100" width="100" viewBox="0 0 100 100" style={{ width: size, height: size }} aria-hidden="true">
			<rect fill="currentColor" id='top' y='21' width='100' height='8'/>,
			<rect fill="currentColor" id='middle' x='6' y='46' width='88' height='8'/>,
			<rect fill="currentColor" id='bottom' y='71' width='100' height='8'/>,
		</svg>
	)
}

export default MenuIcon
